export const sectionErrorTheme = {
  base: {
    borderColor: 'palette.transparent',
    borderRadius: '12px',
    borderWidth: '2px',
  },
  error: {
    borderColor: 'palette.error.60',
    borderRadius: '12px',
    borderWidth: '2px',
  },
};
